/**
 * @generated SignedSource<<c739075fede37830dc32dd9ed4eba366>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JiraAssigneeSelectionType = "ACCOUNT_OWNER" | "ACCOUNT_TAG" | "ACCOUNT_VARIABLE" | "EMAIL" | "RESOURCE_OWNER" | "RESOURCE_TAG" | "%future added value";
export type JiraSpaceSelectionType = "ACCOUNT_TAG" | "ACCOUNT_VARIABLE" | "RESOURCE_TAG" | "SPACE_KEY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UpsertNotificationRuleStepsContainer_notificationRule$data = {
  readonly description: string | null | undefined;
  readonly filterJSON: string;
  readonly groupBy: ReadonlyArray<string>;
  readonly includeCostData: boolean;
  readonly name: string;
  readonly target: {
    readonly assignee?: {
      readonly type: JiraAssigneeSelectionType;
      readonly value: string | null | undefined;
    } | null | undefined;
    readonly description?: string | null | undefined;
    readonly instance?: {
      readonly uuid: any;
    } | null | undefined;
    readonly space?: {
      readonly type: JiraSpaceSelectionType;
      readonly value: string;
    };
    readonly workType?: string;
  } | null | undefined;
  readonly updateSchedule: string | null | undefined;
  readonly uuid: any;
  readonly " $fragmentType": "UpsertNotificationRuleStepsContainer_notificationRule";
};
export type UpsertNotificationRuleStepsContainer_notificationRule$key = {
  readonly " $data"?: UpsertNotificationRuleStepsContainer_notificationRule$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpsertNotificationRuleStepsContainer_notificationRule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpsertNotificationRuleStepsContainer_notificationRule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterJSON",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeCostData",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updateSchedule",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "target",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "JiraInstance",
              "kind": "LinkedField",
              "name": "instance",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JiraSpaceSelection",
              "kind": "LinkedField",
              "name": "space",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "JiraAssigneeSelection",
              "kind": "LinkedField",
              "name": "assignee",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "type": "NotificationRuleJiraTarget",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NotificationRule",
  "abstractKey": null
};
})();

(node as any).hash = "5c536ec941e5769aa26b916ff860f6a6";

export default node;
